import { defineFetcher } from "~/api/_common/defineFetcher"
import { GET } from "~/api/_common/http"
import { BooleanLike } from "~/api/_common/types"
import { RecruitmentStatus } from "~/api/_common/types-for-recruitment"

const getPath = (id: number) => `/short-internships/${id}`

export const fetchGetShortInternshipsById = defineFetcher((id: number): Promise<ShortInternshipDetail> => {
  return GET(getPath(id))
})

// Generated by https://quicktype.io

export interface ShortInternshipDetail {
  id: number
  company_id: number
  industry_id: number
  occupation_id: number
  title: string
  job_type: string
  content: string
  qualification: string
  reward: string
  selection_flow: string
  expected_recruitment_numbers: string
  has_external_application: BooleanLike
  application_url: string
  status: RecruitmentStatus
  category_name: string
  category_display: string
  thumbnail_img_url: string
  url: string
  company: Company
  short_internship_target_grad_years: number[]
  short_internship_schedules: ShortInternshipSchedule[]
}

interface Company {
  id: number
  name: string
  main_img_filename: string
  company_overview: string
  url: string
  main_img_url: string
}

interface ShortInternshipSchedule {
  id: number
  short_internship_id: number
  region_id: number
  starts_on: string
  ends_on: string
  place: string
  address: string
  entry_deadline: string
  schedule_note: null
  entry_deadline_note: null
}
